import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { geneAsyncAction } from 'services/actionConfigs';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { featureName } from './constants';
import { IAuthData, IAuthStore } from './types';
const createAsync = geneAsyncAction(featureName);

const async = {
  getAllDevices: createAsync<string>('getAllDevices'),
};

export type IauthReducerState = {
  authData: IAuthData | null;
  stores: IAuthStore[];
  devices: any[];
};

type MyState = IauthReducerState;

const reducers = {
  saveAuthData: (state: MyState, { payload }: { payload: IAuthData }) => {
    state.authData = payload;
    state.stores = payload.stores;
  },
  expiredToken: (state: MyState) => {
    state.authData = null;
    state.stores = [];
    state.stores = [];
  },
};
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['auth']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) =>
  useAppSelector((state) => get(getCurrentState(state), key, defaultValue));

const selectors = {
  stores: () => selector('stores') as MyState['stores'],
  devices: () => selector('devices') as MyState['devices'],
};

const Slice = createSlice({
  name: featureName,
  initialState: {
    authData: null,
    stores: [],
    devices: [],
    allProductByCategory: [],
  } as MyState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(async.getAllDevices.fetch, (state) => {
        state.devices = [];
      })
      .addCase(async.getAllDevices.success, (state, { payload }) => {
        state.devices = payload;
      })
      .addCase(async.getAllDevices.fail, (state) => {
        state.devices = [];
      });
  },
});

const actions = {
  ...Slice.actions,
  async,
};
const reducer = Slice.reducer;

export { actions, reducer, selectors };
